export default {
  SET_STATUS(state, value) {
    state.session = value.session
    state.eligible = value.eligible
    state.account = value.account
  },
  SET_IS_PROP_TRADING_ACCOUNT: (state, payload) => (state.isPropTradingAccount = payload),
  SET_HAS_ACTIVE_ACCOUNTS(state, value) {
    state.hasActiveAccounts = value
  },
  SET_IS_REFETCH(state, value) {
    state.isRefetch = value
  },
}
